<template>
  <div class="tips" @click.stop v-pageBuried data-page-buried="BG_0YG_WGMTC">
    <img
      class="image"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/97653d34810b33435f7901f8a4e8f0b6.png	"
      alt=""
    />
    <div class="title">暂未获取资格</div>
    <div class="tips-container">
      <div class="tips-item">
        <div class="item-icon">01</div>
        <div>需先开通<span class="orange">年卡或减脂卡</span></div>
      </div>
      <div class="tips-item">
        <div class="item-icon">02</div>
        <div
          >连续<span class="orange">打卡60天</span
          ><span class="mini">(每天2min)</span></div
        >
      </div>
      <div class="tips-item">
        <div class="item-icon">03</div>
        <div>成功后199元<span class="orange">全额返现</span></div>
      </div>
    </div>
    <div
      class="btn"
      @click="bindClick"
      v-clickBuried
      data-click-buried="CLICK_0YG_WGMTC"
      >去开通</div
    >
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {}
  },
  computed: {
    todayPrizeList() {
      let index = this.data.continuous_day
      return (
        (this.data.sign_task[index] && this.data.sign_task[index].goods_list) ||
        []
      )
    }
  },
  methods: {
    bindClick() {
      this.$emit('confirm')
    }
  }
}
</script>
<style lang="scss" scoped>
.tips {
  text-align: center;
  width: 258px;
  padding: 0px 21px 35px;
  background: #fff;
  border-radius: 10px;

  .image {
    margin: 0 auto;
    margin-top: -50px;
    width: 136px;
    height: 105px;
    object-fit: contain;
    margin-bottom: 18px;
  }

  .title {
    font-weight: bold;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.8);
    line-height: 27px;
    margin-bottom: 13px;
  }

  .tips-container {
    .tips-item {
      position: relative;
      font-size: 13px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.6);
      line-height: 18px;
      margin-bottom: 23px;
      display: flex;
      align-items: center;
      justify-content: center;
      .orange {
        color: #f53387;
      }
      .mini {
        font-size: 10px;
      }
      .item-icon {
        position: relative;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        margin-right: 5px;
        background-color: #f53387;
        font-weight: bold;
        font-size: 13px;
        color: #ffffff;
        line-height: 20px;
        text-align: center;
      }
      .item-icon::after {
        position: absolute;
        content: '';
        width: 0px;
        height: 15px;
        left: 50%;
        top: 23px;
        border-left: 1px dashed #f53387;
      }
    }
    .tips-item:last-child {
      .item-icon::after {
        display: none;
      }
    }
  }

  .btn {
    height: 44px;
    background: #f53387;
    border-radius: 22px;
    font-weight: bold;
    font-size: 16px;
    color: #ffffff;
    line-height: 44px;
  }
}
</style>
